import React, { useEffect, useState } from 'react';
import Datatable from '../../../../components/Datatable';
import FormDialog from '../../../../components/Datatable/FormDialog';
import { Autocomplete, Box, Button, Checkbox, Container, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, Snackbar, TextField, Tooltip, Typography, setRef } from '@mui/material';
import api, { create, get_one, update, delete_one } from '../../../../services/api';
import EditIcon from '@mui/icons-material/Edit';
import KeyIcon from '@mui/icons-material/Key';
import { useNotify } from '../../../../components/Datatable/NotifyProvider';
import { useFormError } from '../../../../components/Datatable/FormErrorProvider';
import { RemoveCircleOutline } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../../components/AuthProvider';
import moment, { duration } from 'moment';
import OltTypeSelect from '../../../../components/OltSTypeSelect';
import OltProxySelect from '../../../../components/OltProxySelect';
import OltSelect from '../../../../components/OltSelect';
import FormClient from './FormClient';
import { CTOHistorySignalButton } from '../../../../components/Graphs/SignaHistoryCtoGraph';
import CustomTextField from '../../../../components/CustomTextField';
import FormOltAccess from '../../../provisioning/prov_service/formOltAccess';

export default function CTO() {
    const notify = useNotify()
    const auth = useAuth()
    const error = useFormError()

    const [formState, setFormState] = useState({
        open: false,
        id: null,
    })
    const [formAccess, setFormAccess] = useState({
        open: false,
        id: null,
    })
    const [refresh, setRefresh] = useState(false)
    React.useEffect(() => {
        error.setErrors([])
        document.title = "IPV7 Onu's - CTOs"
    }, [])
    return (
        <>

            <FormOltAccess open={formAccess.open} olt={formAccess.id}
                empresa={formAccess.empresa}
                oltName={formAccess.olt_name}
                handlerClose={() => setFormAccess({ open: false, id: null })}
                handlerSubmit={false}
            />
            <FormItem
                open={formState.open}
                id={formState.id}
                handlerClose={() => setFormState({ open: false, id: null })}
                handlerSubmit={() => {
                    setFormState({ open: false, id: null })
                    setRefresh(true)
                }}
                btnSubmit={formState.id ? 'Atualizar' : 'Salvar'}
                btnClose={'Fechar'}
            ></FormItem>
            <Datatable
                refresh={refresh}
                handlerRefresh={() => setRefresh(!refresh)}
                title='CTOs'
                endpoint='/provisioning/cto'
                options={{
                    customToolbar: () =>
                        <>
                            
                            <Tooltip title="Adicionar">
                                <IconButton disabled={!auth.hasPerm('cto.create')}
                                    onClick={() => setFormState({ open: true, id: null })}
                                >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>

                        </>
                    ,
                    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => ""
                }
                }
                columns={[
                    {
                        name: 'id',
                        label: 'ID',
                        options: {
                            display: false
                        }
                    },
                    {
                        name: 'empresa_id',
                        label: 'empresa_id',
                        options: {
                            display: false
                        }
                    },
                    {
                        name: 'empresa_name',
                        label: 'Empresa',
                        options: {
                            display: false
                        }
                    },
                    {
                        name: "description",
                        label: "Nome",
                    },
                    {
                        name: 'board',
                        label: 'Placa',
                    },
                    {
                        name: 'port',
                        label: 'Porta',
                    },
                    {
                        name: 'capacity',
                        label: 'Total de Portas',
                    },
                    {
                        name: 'used_ports',
                        label: 'Portas Ocupadas',
                    },
                    {
                        name: 'active',
                        label: 'Ativo',
                        options: {
                            customBodyRender: (value) => value == 1 ? 'Sim' : 'Não'
                        }
                    },
                    {
                        name: 'created_at',
                        label: 'Criado em',
                        options: {
                            customBodyRender: value => <span>{moment(value).locale('pt-br').format('DD-MM-YYYY HH:mm:ss')}</span>,
                        }
                    },
                    {
                        name: 'updated_at',
                        label: 'Atualizado em',
                        options: {
                            customBodyRender: value => <span>{moment(value).locale('pt-br').format('DD-MM-YYYY HH:mm:ss')}</span>,
                        }
                    },
                    {
                        name: 'actions',
                        label: 'Ações',
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return (
                                    <>
                                        <Tooltip title="Editar">
                                            <IconButton disabled={!auth.hasPerm('cto.update')}
                                                onClick={() => setFormState({ open: true, id: tableMeta.rowData[0] })}
                                            >
                                                <EditIcon />

                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={"ONUS"}>
                                            <FormClient id={tableMeta.rowData[0]} cto={tableMeta.rowData[3]} />
                                        </Tooltip>
                                        <CTOHistorySignalButton cto={tableMeta.rowData[0]} title={tableMeta.rowData[3]} />
                                    </>
                                )
                            }
                        }
                    }
                ]}

            />
        </>
    )
}




function FormItem({ id, open, handlerClose, handlerSubmit, btnClose = 'Fechar', btnSubmit = 'Salvar' }) {
    const notify = useNotify()
    const error = useFormError()
    const auth = useAuth()
    const [isLoaded, setIsLoaded] = React.useState(true)
    const modelState = {
        description: '',
        board: '',
        port: '',
        capacity: '',
        used_ports: '',
        lat: null,
        long: null,
        olt: null,
        active: 1,
    }
    const [state, setState] = useState(modelState)

    useEffect(() => {
        setState(modelState)
        if (!open) return
        error.setErrors([])
        if (id) {
            setIsLoaded(false)
            get_one('/provisioning/cto', id).then(res => {
                setState(res.data.data)
                setIsLoaded(true)

            }).catch(e => {
                console.log(e)
                setIsLoaded(true)
            })
        }
    }, [id, open])



    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    }

    const wrapperSubmit = () => {

        if (id) {
            update('/provisioning/cto', id, state).catch(e => notify
                .setNotify({ open: true, message: e.message, severity: 'error' }))
                .then(res => {
                    if (res.data.error) {
                        notify.setNotify({ open: true, message: res.data.error, severity: 'error', duration:null })
                        return
                    }
                    if (res.data.errors) {
                        error.setErrors(res.data.errors)
                        return
                    }
                    handlerSubmit()
                    notify.setNotify({ open: true, message: 'CTO atualizada com sucesso', severity: 'success' })
                    error.setErrors([])
                }).catch(e => notify.setNotify({ open: true, message: e.message, severity: 'error' }))
        }
        else {
            create('/provisioning/cto/create', state)
                .then(res => {
                    if (res.data.error) {
                        notify.setNotify({ open: true, message: res.data.error, severity: 'error' })
                        return
                    }
                    if (res.data.errors) {
                        error.setErrors(res.data.errors)
                        return
                    }
                    handlerSubmit()
                    notify.setNotify({ open: true, message: 'CTO criada com sucesso.', severity: 'success' })
                    error.setErrors([])
                })
                .catch(e =>
                    notify.setNotify({ open: true, message: e.message, severity: 'error' }))
        }

    }
    return (
        <Box component={"form"}
            onSubmit={wrapperSubmit}
            sx={{ m: 2 }}
            display={'flex'}
            flexWrap={'wrap'}
        >

            <FormDialog
                isLoaded={isLoaded}
                title={
                    <Box display={"flex"} justifyContent={'space-between'}>
                        <Typography variant="h6" component="div">{id ? 'Editar' : 'Adicionar'} CTO</Typography>
                        <IconButton disabled={!auth.hasPerm("cto.delete")}
                            sx={{ display: id ? 'block' : 'none' }}
                            onClick={() => {
                                if (confirm('Deseja excluir a CTO?')) {
                                    delete_one('/provisioning/cto', id).then(res => {
                                        notify.setNotify({ open: true, message: 'CTO deletada com sucesso.', severity: 'success' })
                                        handlerClose()
                                        handlerSubmit()
                                    })
                                }
                            }}>
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                }
                open={open}
                handlerSubmit={wrapperSubmit}
                handlerClose={handlerClose}
                btnSubmit={btnSubmit}
                btnClose={btnClose}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <OltSelect
                        sx={{ mt: 1 }}
                        value={state.olt}
                        handler={(e) => setState({ ...state, olt: e })}
                        admin={false}
                    />
                    <CustomTextField
                        sx={{ mb: 2, mt: 2 }}
                        error={error.verify('board')}
                        helperText={error.msgError('board')}
                        label='Placa'
                        value={state.board}
                        name={'board'}
                         type="number"
                        inputProps={{ max: 24 }}
                        onChange={handleChange}
                    />
                    <CustomTextField
                        sx={{ mb: 2 }}
                        error={error.verify('port')}
                        helperText={error.msgError('port')}
                        label='Porta'
                        value={state.port}
                        type="number"
                        name={'port'}
                        onChange={handleChange}
                    />
                    <CustomTextField
                        sx={{ mb: 2, }}
                        error={error.verify('description')}
                        helperText={error.msgError('description')}
                        label='Nome'
                        value={state.description}
                        name={'description'}
                        onChange={handleChange}
                    />
                    <CustomTextField
                        sx={{ mb: 2 }}
                        error={error.verify('lat')}
                        helperText={error.msgError('lat')}
                        label='Latitude'
                        value={state.lat}
                        name={'lat'}
                        onChange={handleChange}
                    />
                    <CustomTextField
                        sx={{ mb: 2 }}
                        error={error.verify('long')}
                        helperText={error.msgError('long')}
                        label='Longitute'
                        value={state.long}
                        name={'long'}
                        onChange={handleChange}
                    />
                    <CustomTextField
                        sx={{ mb: 2 }}
                        error={error.verify('capacity')}
                        helperText={error.msgError('capacity')}
                        label='Capacidade'
                        value={state.capacity}
                        name={'capacity'}
                        type="number"
                        onChange={handleChange}
                    />
                    <CustomTextField
                        sx={{ mb: 2 }}
                        error={error.verify('used_ports')}
                        helperText={error.msgError('used_ports')}
                        label='Portas Ocupadas'
                        value={state.used_ports}
                         type="number"
                        name={'used_ports'}
                        onChange={handleChange}
                    />
                    <FormGroup>
                        <FormControlLabel control={
                            <Checkbox
                                checked={state?.active}
                                onChange={(e) => setState({ ...state, active: e.target.checked ? 1 : 0 })}
                            />
                        }
                            label="Ativo"
                        />
                    </FormGroup>



                </Box>

            </FormDialog>
        </Box>
    )
}
